module.exports = __webpack_public_path__ + "img/money.a1892f7a.jpg";